import img3 from "../img/persona.png"
import "../css/AboutUs.css"

const AboutUs = () => {
  return (
    <section className="about-us-section">
      <div className="about-us-container">
        <div className="about-us-image">
          <img src={img3 || "/placeholder.svg"} alt="Persona en uniforme rojo" />
        </div>
        <div className="about-us-content">
          <h2 className="about-us-title">SOBRE NOSOTROS</h2>
          <div className="about-us-underline"></div>
          <p className="about-us-text">
            ¡Más de 40 años de experiencia ofreciendo los mejores repuestos industriales, automotrices y la fabricación
            de aceros! Somos los distribuidores autorizados de marcas internacionales contando con repuestos de alta
            calidad, precios competitivos y garantía de fábrica.
          </p>
        </div>
      </div>
    </section>
  )
}

export default AboutUs
